<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-form-item label="排序:">
                        <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="标题:">
                        <el-input v-model="table.where.title" placeholder="请输入标题" clearable />
                    </el-form-item>
                    <el-form-item label="作者:">
                        <el-input v-model="table.where.author" placeholder="请输入作者" clearable />
                    </el-form-item>
                    <el-form-item label="内容:">
                        <el-input v-model="table.where.contant" placeholder="请输入内容" clearable />
                    </el-form-item>
                    <el-form-item label="浏览量:">
                        <el-input-number v-model="table.where.browse_num" placeholder="请输入浏览量" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="点赞数量:">
                        <el-input-number v-model="table.where.laud_num" placeholder="请输入点赞数量" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="关联 文章类别id:">
                        <el-select v-model="table.where.type_id" filterable placeholder="请选择">

                            <el-option v-for="item in article_type_list" :key="item.id" :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="评论状态:">
                        <el-select v-model="table.where.comment_status" filterable placeholder="请选择">
                            <el-option label="开启评论" value="2"></el-option>
                            <el-option label="关闭评论" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审核状态:">
                        <el-select v-model="table.where.comment_judge" filterable placeholder="请选择">
                            <el-option label="审核" value="2"></el-option>
                            <el-option label="不审核" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="显示样式:">
                        <el-select v-model="table.where.mode" filterable placeholder="请选择">
                            <el-option label="小图" value="2"></el-option>
                            <el-option label="多图" value="3"></el-option>
                            <el-option label="大图" value="4"></el-option>
                            <el-option label="视频" value="5"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标签:">
                        <el-input v-model="table.where.article_card" placeholder="请输入标签" clearable />
                    </el-form-item>
                    <el-form-item label="推荐:">
                        <el-select v-model="table.where.article_status" filterable placeholder="请选择">
                            <el-option label="普通" value="2"></el-option>
                            <el-option label="热门" value="3"></el-option>
                            <el-option label="推荐" value="4"></el-option>
                            <el-option label="置顶" value="5"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间:">
                        <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>



                    <el-form-item>
                        <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                            class="ele-btn-icon">查询
                        </el-button>
                        <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                            v-if="permission.includes('sys:article:export')">导出数据
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->

            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                    class="ele-btn-icon" size="small">刷新
                </el-button>
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:article:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:article:dall')">批量删除
                </el-button>
                <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                    @click="search_show=!search_show">搜索</el-button>
            </div>

            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />
                    <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="title" label="标题" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="author" label="作者" sortable="custom" show-overflow-tooltip min-width="120" />

                    <!-- <el-table-column prop="contant" label="内容" sortable="custom" show-overflow-tooltip  min-width="120" /> -->

                    <el-table-column prop="image" label="图片" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-image style="width: 50px; height: 50px" :src="row.image"
                                :preview-src-list="[row.image]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="browse_num" label="浏览量" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="laud_num" label="点赞数量" sortable="custom" show-overflow-tooltip
                        min-width="120" />


                    <el-table-column prop="type_id" label="关联 文章类别id" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.type_id_info" :key="index">{{item.title}}</el-tag>
                        </template>
                    </el-table-column>


                    <el-table-column prop="comment_status" label="评论状态" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.comment_status == 2" :key="index">开启评论</el-tag>
                            <el-tag v-if="row.comment_status == 3" :key="index">关闭评论</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="comment_judge" label="审核状态" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.comment_judge == 2" :key="index">审核</el-tag>
                            <el-tag v-if="row.comment_judge == 3" :key="index">不审核</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="mode" label="显示样式" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.mode == 2" :key="index">小图</el-tag>
                            <el-tag v-if="row.mode == 3" :key="index">多图</el-tag>
                            <el-tag v-if="row.mode == 4" :key="index">大图</el-tag>
                            <el-tag v-if="row.mode == 5" :key="index">视频</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="video_file" label="视频地址" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <a :href="row.video_file" target="_blank">
                                <el-tag>文件</el-tag>
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="article_card" label="标签" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="article_status" label="推荐" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.article_status == 2" :key="index">普通</el-tag>
                            <el-tag v-if="row.article_status == 3" :key="index">热门</el-tag>
                            <el-tag v-if="row.article_status == 4" :key="index">推荐</el-tag>
                            <el-tag v-if="row.article_status == 5" :key="index">置顶</el-tag>
                        </template>
                    </el-table-column>


                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:article:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此文章列表吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:article:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改文章列表':'添加文章列表'" :visible.sync="showEdit" width="800px"
            :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
               
                <el-form-item label="标题:" prop="title">
                    <el-input v-model="editForm.title" placeholder="请输入标题" clearable />
                </el-form-item>
                <el-form-item label="作者:" prop="author">
                    <el-input v-model="editForm.author" placeholder="请输入作者" clearable />
                </el-form-item>
                <el-form-item label="内容:" prop="contant">
                    <tinymce-editor v-model="editForm.contant" :init="initEditor" />
                </el-form-item>
                <el-form-item label="图片:" prop="image">
                    <ele-uploadimage :limit="1" v-model="editForm.image"></ele-uploadimage>

                </el-form-item>
                <el-form-item label="浏览量:" prop="browse_num">
                    <el-input-number v-model="editForm.browse_num" controls-position="right" :controls="false"
                        :precision="0" class="ele-fluid ele-text-left" placeholder="请输入浏览量" clearable />
                </el-form-item>
                <el-form-item label="点赞数量:" prop="laud_num">
                    <el-input-number v-model="editForm.laud_num" controls-position="right" :controls="false"
                        :precision="0" class="ele-fluid ele-text-left" placeholder="请输入点赞数量" clearable />
                </el-form-item>

                <el-form-item label="关联 文章类别id:" prop="type_id">
                    <el-select v-model="editForm.type_id" filterable placeholder="请选择">
                        <el-option v-for="item in article_type_list" :key="item.id" :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评论状态:" prop="comment_status">
                    <el-select v-model="editForm.comment_status" filterable placeholder="请选择评论状态">
                        <el-option label="开启评论" value="2"></el-option>
                        <el-option label="关闭评论" value="3"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="审核状态:" prop="comment_judge">
                    <el-select v-model="editForm.comment_judge" filterable placeholder="请选择审核状态">
                        <el-option label="审核" value="2"></el-option>
                        <el-option label="不审核" value="3"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="显示样式:" prop="mode">
                    <el-select v-model="editForm.mode" filterable placeholder="请选择显示样式">
                        <el-option label="小图" value="2"></el-option>
                        <el-option label="多图" value="3"></el-option>
                        <el-option label="大图" value="4"></el-option>
                        <el-option label="视频" value="5"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="视频地址:" prop="video_file">
                    <ele-upload-resource-other :limit="1" v-model="editForm.video_file"></ele-upload-resource-other>

                </el-form-item>
                <el-form-item label="标签:" prop="article_card">
                    <el-input v-model="editForm.article_card" placeholder="请输入标签" clearable />
                </el-form-item>
                <el-form-item label="推荐:" prop="article_status">
                    <el-select v-model="editForm.article_status" filterable placeholder="请选择推荐">
                        <el-option label="普通" value="2"></el-option>
                        <el-option label="热门" value="3"></el-option>
                        <el-option label="推荐" value="4"></el-option>
                        <el-option label="置顶" value="5"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序:" prop="sort">
                    <el-input-number v-model="editForm.sort" controls-position="right" :controls="false" :precision="0"
                        class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    import EleUploadimage from '@/components/EleUploadimage'
    import EleUploadResourceOther from '@/components/EleUploadResourceOther'
    import TinymceEditor from '@/components/TinymceEditor'
    export default {
        name: "SysArticle",
        components: {
            EleUploadimage,
            EleUploadResourceOther,
            TinymceEditor
        },
        data() {
            return {
                table: {
                    url: '/article/Article/index',
                    where: {
                        "image": [],
                        "video_file": []
                    }
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    "image": [],
                    "video_file": []
                }, // 表单数据
                editFormTemp: {
                    "image": [],
                    "video_file": []
                },
                admin_list: [],
                user_list: [],
                search_show: false,
                article_type_list: [],
                editRules: { // 表单验证规则

                    sort: [{
                        required: true,
                        message: '请输入排序',
                        trigger: 'blur'
                    }],


                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }],

                    contant: [{
                        required: true,
                        message: '请输入内容',
                        trigger: 'blur'
                    }],


                    type_id: [{
                        required: true,
                        message: '请选择关联 文章类别',
                        trigger: 'blur'
                    }],

                    article_card: [{
                        required: true,
                        message: '请输入标签',
                        trigger: 'blur'
                    }],




                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
            initEditor() {
                return {
                    height: 400,
                    file_picker_callback: this.file_picker_callback,
                    skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                        '/tinymce/skins/ui/oxide',
                    content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' :
                        '/tinymce/skins/content/default/content.css',
                    images_upload_handler: (blobInfo, success, error) => {
                        let file = blobInfo.blob();
                        // 使用axios上传
                        const formData = new FormData();
                        formData.append('file', file, file.name);
                        this.$http.post('/upload/uploadImage', formData).then(res => {
                            if (res.data.code == 0) {
                                success(res.data.data);
                            } else {
                                error(res.data.msg);
                            }
                        }).catch(e => {
                            error(e.message);
                        });
                    }
                };
            }
        },
        mounted() {

            this.ArticleTypeAllList();
        },
        methods: {
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/article/Article/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/article/Article/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的文章列表吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/article/Article/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/article/Article/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 导出数据Excel */
            exportExcel() {
                let ids  = this.choose.map(d => d.id)
                if(ids.length == 0){
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {id:ids})
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
            //查询其他信息
            ArticleTypeAllList() {
                this.$http.post('/article/ArticleType/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.article_type_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },

        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>
